import { Trophy } from "lucide-react";
import { useEffect, useState } from "react";
import { toast } from "sonner";

import { api } from "@/api";

// Étapes « gagné » de chaque pipeline actif : un dossier qui y arrive devient un client
export function WonStepsSection({ pipelines }) {
  const [won, setWon] = useState(null);
  const [open, setOpen] = useState(null);
  useEffect(() => { api.get("/settings/won-steps").then(({ data }) => setWon(data.pipelines)).catch(() => setWon(false)); }, []);
  if (!won) return null;
  const toggle = async (name, id) => {
    const cur = won[name] || [];
    const next = { ...won, [name]: cur.includes(id) ? cur.filter((x) => x !== id) : [...cur, id] };
    setWon(next);
    try { const { data } = await api.put("/settings/won-steps", { pipelines: next }); setWon(data.pipelines); toast.success(`Étapes « gagné » enregistrées · ${data.clients} clients.`); } catch (e) { toast.error(e?.response?.data?.detail || "Erreur, réessayez."); }
  };
  return (
    <section className="settings-section" data-testid="won-steps-section">
      <div className="section-title"><Trophy size={20} /><div><p className="eyebrow">CLIENTS</p><h2>Étapes « gagné » par pipeline</h2></div></div>
      <p className="fileprep-dedup-hint">Un dossier au statut Gagnée ou arrivé à l'une de ces étapes devient un client (même téléphone ou e-mail = même client). Rien n'est modifié dans noCRM.</p>
      <ol className="pls-list">
        {pipelines.filter((p) => !p.hidden).map((p, i) => (
          <li key={p.name} data-testid={`won-row-${i}`}>
            <div className="pls-row"><button type="button" className="pls-name" onClick={() => setOpen(open === p.name ? null : p.name)} data-testid={`won-open-${i}`}>{p.name} <small>{(won[p.name] || []).length ? `${(won[p.name] || []).length} étape(s) « gagné »` : "statut Gagnée seulement"}</small></button></div>
            {open === p.name && <div className="pls-steps">{p.steps.map((s) => <button key={s.id} type="button" className={`rc-chip${(won[p.name] || []).includes(s.id) ? " on" : ""}`} onClick={() => toggle(p.name, s.id)} data-testid={`won-step-${s.id}`}>{s.name}</button>)}</div>}
          </li>
        ))}
      </ol>
    </section>
  );
}
